module.exports = __webpack_public_path__ + "img/sketch.29fc4974.svg";